import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../components/ExportToExcel";
import Pagination from "../../../components/Pagination";
import SearchBar from "../../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Dynamic_FilterForm from "./Dynamic_FilterForm";

const Dynamic_PR_table = ({
  data,
  selectedResource,
  selectAllChecked,
  columns,
  defaultColumns,
  handleBtn,
  itemsPerPage,
  searchTerm,
  setSearchTerm,
  handleIconClick,
  icons,
  isActionRequired,
  isCheckBoxRequired,
  isAddNewBtnRequired,
  isFilterRequired,
  formDatas,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  handleIcon1,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  handleIcon5,
  handleGetData,
  handleAddNew,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  handleSelectAllChange,
}) => {
  const [visibleColumns, setVisibleColumns] = useState(defaultColumns);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns({
      ...visibleColumns,
      [columnName]: !visibleColumns[columnName],
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();

  const sortedData = useMemo(() => {
    let sortableItems = [...data];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        const valA = a[sortConfig.key] ? String(a[sortConfig.key]) : '';
        const valB = b[sortConfig.key] ? String(b[sortConfig.key]) : '';
  
        // Split the values into alphabetical and numeric parts
        const partsA = valA.match(/(\D+|\d+)/g) || [];
        const partsB = valB.match(/(\D+|\d+)/g) || [];
  
        for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
          const partA = partsA[i] || '';
          const partB = partsB[i] || '';
  
          // Determine if parts are numeric or alphabetical
          const isNumericA = !isNaN(partA);
          const isNumericB = !isNaN(partB);
  
          if (isNumericA && isNumericB) {
            // Both parts are numeric, so compare as numbers
            const numA = parseInt(partA, 10);
            const numB = parseInt(partB, 10);
            if (numA !== numB) {
              return sortConfig.direction === "ascending" ? numA - numB : numB - numA;
            }
          } else if (isNumericA || isNumericB) {
            // One part is numeric and the other is alphabetical
            return isNumericA ? -1 : 1;
          } else {
            // Both parts are alphabetical, so compare as strings
            if (partA !== partB) {
              return sortConfig.direction === "ascending"
                ? partA.localeCompare(partB)
                : partB.localeCompare(partA);
            }
          }
        }
  
        return 0;
      });
    }
    return sortableItems;
  }, [data, sortConfig]);
  
  

  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  const handleSort = (columnName) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === columnName &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key: columnName, direction });
  };

 
  const formatDate = (date) => {
    if (!date) return ""; // Handle null or undefined dates

    // Check if the date is already in DD-MM-YYYY format
    const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
    if (dateRegex.test(date)) {
      return moment(date).format("DD-MMM-YYYY");
    }

    return moment(date).format("DD-MMM-YYYY");
  };

  console.log("currentData",currentData)

  return (
    <div>
      <div className="d-flex justify-content-between">
        <div className="d-flex">
          <div className="me-1">
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          {isFilterRequired && (
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>

              <div
                className="dropdown-menu custom-dropdown-width"
                aria-labelledby="excel-btn"
                onClick={(e) => e.stopPropagation()}
              >
                <Dynamic_FilterForm
                  formData={formDatas  || []}
                  handleChange={handleChange}
                  handleGetData={handleGetData}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end">
          <div className="me-1">
            <ExportToExcel data={filteredData} filename="tableData.xlsx" />
          </div>
          <div className="btn-group me-2">
            <button
              type="button"
              className="dropdown-toggle skill-button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              id="excel-btn"
            >
              <i className="bi bi-list"></i>
            </button>
            <ul className="dropdown-menu p-2">
              <div className="row">
                <Form.Group>
                  {Object.keys(visibleColumns).map((columnName) => (
                    <Form.Check
                      key={columnName}
                      type="checkbox"
                      id={`checkbox-${columnName}`}
                      label={columnName}
                      checked={visibleColumns[columnName]}
                      onChange={() => toggleColumn(columnName)}
                    />
                  ))}
                </Form.Group>
              </div>
            </ul>
          </div>
          {isAddNewBtnRequired && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
            >
              <button id="Add-btn" onClick={handleAddNew}>
                <i className="fa fa-plus"></i> Add
              </button>
            </OverlayTrigger>
          )}
        </div>
      </div>

      <div className="box-body table-responsive container-fluid px-0">
        <Table bordered striped hover>
          <thead id="thcolor" className="text-center">
            <tr>
              {isCheckBoxRequired && (
                <th>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectAllChecked}
                    onChange={(e) => handleSelectAllChange(e)}
                  />
                </th>
              )}
              {Object.keys(columns).map(
                (columnName) =>
                  visibleColumns[columnName] && (
                    <th
                      style={{
                        whiteSpace: "nowrap",
                      }}
                      key={columnName}
                      onClick={() => handleSort(columnName)}
                    >
                      {columns[columnName].text}
                      <span className="ms-2">
                        {sortConfig.key === columnName ? (
                          sortConfig.direction === "ascending" ? (
                            <i className="bi bi-chevron-up"></i>
                          ) : (
                            <i className="bi bi-chevron-down"></i>
                          )
                        ) : (
                          <i className="bi bi-chevron-down"></i>
                        )}
                      </span>
                    </th>
                  )
              )}
              {isActionRequired && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {currentData.map((item, index) => (
              <tr key={index}>
                {isCheckBoxRequired && (
                  <td>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={!!selectedResource.find(
                        (o) => o.EmployeeID === item.EmployeeID
                      )}
                      onChange={(e) =>
                        handleCheckboxChange(e, item.EmployeeID, item)
                      }
                    />
                  </td>
                )}
                {Object.keys(columns).map((columnName) => {
                  const isDateColumn = columns[columnName].text
                    .toLowerCase()
                    .includes("Date");
                  const columnAlignment = columns[columnName].align || "left";
                  const columnWidth = columns[columnName].width;

                  const isButtonColumn = columns[columnName].type === "button";
                  const isButtonName = columns[columnName].text;
                  const hasIcon = columns[columnName].icon;

                  return (
                    visibleColumns[columnName] &&
                    (item[columnName] !== null &&
                    item[columnName] !== undefined ? (
                      <OverlayTrigger
                        key={columnName}
                        placement="right"
                        overlay={
                          <Tooltip id={`tooltip-${columnName}`}>
                            {item[columnName]}
                          </Tooltip>
                        }
                      >
                        <td
                          className={`text-${columnAlignment} text-truncate`}
                          style={{
                            maxWidth: columnWidth || "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {isButtonColumn ? (
                            <button
                              className={`text-${columnAlignment} custom-btn`}
                              onClick={() => handleBtn(columnName, item)}
                            >
                              {isButtonName}
                            </button>
                          ) : hasIcon ? (
                            <div
                              className="d-flex align-items-center justify-content-center text-center"
                              onClick={() => handleIconClick(columnName, item)}
                            >
                              <span className="me-2">
                                {icons[columns[columnName].icon]}
                              </span>
                              {item[columnName]}
                            </div>
                          ) : isDateColumn ? (
                            formatDate(item[columnName])
                          ) : (
                            item[columnName]
                          )}
                        </td>
                      </OverlayTrigger>
                    ) : (
                      <td
                        key={columnName}
                        className={`text-${columnAlignment} text-truncate`}
                        style={{
                          maxWidth: columnWidth || "60px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {isButtonColumn ? (
                          <button
                            className={`text-${columnAlignment} custom-btn`}
                            onClick={() => handleBtn(columnName, item)}
                          >
                            {isButtonName}
                          </button>
                        ) : hasIcon ? (
                          // <OverlayTrigger
                          //   placement="bottom"
                          //   overlay={
                          //     <Tooltip id="tooltip-bottom">
                          //       {item[columns[columnName].iconText] || "Edit"}
                          //     </Tooltip>
                          //   }
                          // >
                            <div
                              className="d-flex align-items-center justify-content-center text-center"
                              onClick={() => handleIconClick(columnName, item)}
                            >
                              <span className="me-2">
                                {icons[columns[columnName].icon]}
                              </span>
                              {item[columnName]}
                            </div>
                          // </OverlayTrigger>
                        ) : isDateColumn ? (
                          formatDate(item[columnName])
                        ) : (
                          item[columnName]
                        )}
                      </td>
                    ))
                  );
                })}
               {isActionRequired && (
                  <td>
                    <div className="d-flex justify-content-center text-center">
                      {showIcon1 && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="tooltip-bottom">
                              {icons.Icon1Text || "Edit"}
                            </Tooltip>
                          }
                        >
                          <div
                            className="me-2"
                            onClick={() => handleIcon1(item)}
                          >
                            {icons.Icon1}
                          </div>
                        </OverlayTrigger>
                      )}
                      {showIcon2 && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="tooltip-bottom">
                              {icons.Icon2Text || "Edit"}
                            </Tooltip>
                          }
                        >
                          <div
                            className="me-2"
                            onClick={() => handleIcon2(item)}
                          >
                            {icons.Icon2}
                          </div>
                        </OverlayTrigger>
                      )}
                      {showIcon3 && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="tooltip-bottom">
                              {icons.Icon3Text}
                            </Tooltip>
                          }
                        >
                          <div
                            className="me-2"
                            onClick={() => handleIcon3(item)}
                          >
                            {icons.Icon3}
                          </div>
                        </OverlayTrigger>
                      )}
                      {showIcon4 && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="tooltip-bottom">
                              {icons.Icon4Text || "Add"}
                            </Tooltip>
                          }
                        >
                          <div
                            className="me-2"
                            onClick={() => handleIcon4(item)}
                          >
                            {icons.Icon4}
                          </div>
                        </OverlayTrigger>
                      )}
                      {showIcon5 && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="tooltip-bottom">
                              {icons.Icon5Text || "Add"}
                            </Tooltip>
                          }
                        >
                          <div
                            className="me-2"
                            onClick={() => handleIcon5(item)}
                          >
                            {icons.Icon5}
                          </div>
                        </OverlayTrigger>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
        {filteredData.length > itemsPerPage && (
         <div className="d-flex justify-content-end">
         <Pagination
           itemsPerPage={itemsPerPage}
           totalItems={filteredData.length}
           currentPage={currentPage}
           onPageChange={handlePageChange}
         />
       </div>
        )}
      </div>
    </div>
  );
};

export default Dynamic_PR_table;
